<template>
	<div class="content">
		<div class="last-eat" v-if="lastEatTime">
			<!-- <div class="today-num gold_price">
				<div class="vertical-data">
					黄金买价:<span class="bold-font">
						{{ goldInfo?.buy_price }}
					</span>
				</div>
				<div class="vertical-data">
					黄金卖价:<span class="bold-font">
						{{ goldInfo?.sell_price }}
					</span>
				</div>
				<div class="vertical-data">
					更新日期:<span class="bold-font">
						{{ goldInfo?.uptime }}
					</span>
				</div>
			</div> -->
			<div>距离上次吃奶已经过去<span class="bold-font ">{{ internalTime }}</span>小时
				(<span class="bule-font" @click="refreshPage">刷新</span>)
			</div>
			<div>上次吃奶时间：<span class="bold-font">{{ lastEatTime }}</span></div>
			<div class="today-num">
				<div>
					上次吃奶:<span class="bold-font">
						{{ lastEatNumber }}
					</span>
				</div>
				<div>
					今日吃奶:<span class="bold-font">
						{{ totalNum }}
					</span>
				</div>
			</div>
		</div>
		<div class="time_select" :class="{ time_selected: selectTimeIndex > -1 }">
			<van-button type="primary" :class="{ selected_button: selectTimeIndex === 60 }"
				@click="selectedTime(60)">一小时前</van-button>
			<van-button type="info" :class="{ selected_button: selectTimeIndex === 30 }"
				@click="selectedTime(30)">30分钟前</van-button>
			<van-button type="warning" :class="{ selected_button: selectTimeIndex === 15 }"
				@click="selectedTime(15)">15分钟前</van-button>
			<van-button type="danger" :class="{ selected_button: selectTimeIndex === 5 }"
				@click="selectedTime(5)">5分钟前</van-button>
		</div>
		<div class="current_time">
			<div class="custom_time">自定义时间(几分钟前):<van-field type="digit" @input="inputCustomTime" v-model="customTime"
					label="" placeholder="多少分钟前吃的奶" /></div>
		</div>
		<div class="time_select" :class="{ time_selected: selectNumIndex > -1 }">
			<van-button v-for="(_, index) in volumeSettings" :key="index" :type="getEatenVolumeType(index)" :class="{ selected_button: selectNumIndex === volumeSettings[index] }"
				@click="selectedNum(volumeSettings[index])">{{volumeSettings[index]}}</van-button>
		</div>
		<div class="current_time">
			<div class="custom_time">自定义奶量(多少毫升):<van-field type="digit" @input="inputCustomNum" v-model="customNum"
					label="" placeholder="吃了多少毫升" /></div>
		</div>
		<div class="final_data">
			<div>
				<div>时间：<span class="red-font bold-font">{{ eatTime }}</span></div>
				<div>奶量：<span class="red-font bold-font">{{ eatNum }}ML</span></div>
			</div>
			<van-button plain type="primary" @click="addEatRecord">点击记录</van-button>
		</div>
		<div class="data-list" v-if="dataList.length > 0">
			<div class="data-list-item data-list-header">
				<span class="data-list_num">饭量</span>
				<span class="data-list_interval">间隔</span>
				<span class="data-list_time">时间</span>
				<span class="data-list_operate">操作</span>
			</div>
			<!-- <van-list> -->
			<div class="data-list-content">
				<div class="data-list-item" v-for="item in dataList" :key="item.id">
					<span class="data-list_num">{{ item.num }}</span>
					<span class="data-list_interval">{{ item.interval }}</span>
					<span class="data-list_time">{{ item.time }}</span>
					<span class="data-list_operate">
						<van-button type="danger" size="small" @click="deleteEatRecord(item.id)">删除</van-button>
					</span>
				</div>
			</div>

			<!-- </van-list> -->
		</div>
	</div>
</template>

<script>
import {
	getList,
	getGoldPrice,
	addEatRecord,
	deleteEatRecord,
	getUserPreference,
	getTotalListByDate
} from '../util/api'
import { Dialog } from 'vant';
export default {
	name: 'IndexCom',
	data() {
		return {
			selectTimeIndex: -1,
			selectNumIndex: -1,
			customTime: null,
			customNum: null,
			eatTime: new Date().toLocaleString(),
			eatNum: 0,
			lastEatTime: null,
			lastEatNumber: null,
			internalTime: null,
			intervalId: null,
			volumeSettings: [],
			dataList: [],
			totalNum: 0,
			goldInfo: {}
		}
	},
	methods: {
		refreshPage: () => {
			location.reload()
		},
		getGoldPrice(){
			getGoldPrice().then((res) => {
				this.goldInfo = res.data.data
			})
		},
		getList: function () {
			getList({
				startDate: this.getPastMonthDate(6),
				endDate: this.getPastMonthDate(0)
			}).then((res) => {
				const data = res.data.sort((a, b) => new Date(b.time) - new Date(a.time));
				const dataNew = data.map((item, index) => {
					if (index < (data.length - 1)) {
						item.interval = `${((new Date(item.time).getTime() - new Date(data[index + 1].time).getTime()) / (1000 * 60 * 60)).toFixed(2)}h`
					} else {
						item.interval = null
					}
					return item
				})
				this.handleData(dataNew);
				this.getTotalListByDate();
			})
		},
		getTotalListByDate() {
			const date = new Date()
			const todayDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
			getTotalListByDate({ startDate: todayDate, endDate: todayDate }).then((res) => {
				if (res?.data?.length > 0) {
					this.totalNum = res.data[0].total
				}else{
					this.totalNum = 0
				}
			})
		},
		handleData: function (data) {
			this.dataList = data || []
			if (data && data.length > 0) {
				const lastTime = data[0]
				this.$set(this, 'lastEatTime', lastTime.time);
				this.$set(this, 'lastEatNumber', lastTime.num);
				this.$set(this, 'internalTime', ((new Date().getTime() - new Date(lastTime.time).getTime()) / (1000 * 60 * 60)).toFixed(2));
			} else {
				this.$set(this, 'lastEatTime', null);
				this.$set(this, 'lastEatNumber', null);
				this.$set(this, 'internalTime', null);
			}
		},
		addEatRecord: function () {
			addEatRecord({
				num: this.eatNum, time: this.eatTime
			}).then(() => {
				this.getList()
			})
		},
		deleteEatRecord: function (id) {
			Dialog.confirm({
				message: '确认删除这次记录吗'
			}).then(() => {
				deleteEatRecord({
					id: id
				}).then(() => {
					this.getList()
				})
			}).catch(() => {
				// on cancel
			});

		},
		selectedTime: function (index) {
			const isCancel = index === this.selectTimeIndex
			if (isCancel) {
				this.$set(this, 'selectTimeIndex', -1);
			} else {
				this.$set(this, 'selectTimeIndex', parseInt(index));
			}
			this.$set(this, 'customTime', null);
			this.$set(this, 'eatTime', this.computeTime(isCancel ? 0 : parseInt(index)));
		},
		selectedNum: function (index) {
			const isCancel = index === this.selectNumIndex
			if (isCancel) {
				this.$set(this, 'selectNumIndex', -1);
			} else {
				this.$set(this, 'selectNumIndex', parseInt(index));
			}
			this.$set(this, 'customNum', null);
			this.$set(this, 'eatNum', isCancel ? 0 : parseInt(index));
		},
		computeTime: (minute) => {
			const now = new Date();
			now.setMinutes(now.getMinutes() - minute);
			return now.toLocaleString()
		},
		inputCustomTime: function () {
			if (this.customTime) {
				this.$set(this, 'selectTimeIndex', -1);
				this.$set(this, 'eatTime', this.computeTime(this.customTime));
			}
		},
		inputCustomNum: function () {
			if (this.customNum) {
				this.$set(this, 'selectNumIndex', -1);
				this.$set(this, 'eatNum', this.customNum);
			}
		},

		getPastMonthDate(daysAgo) {
			const today = new Date();
			const needDaysAgo = new Date(today.setDate(today.getDate() - daysAgo));
			const year = needDaysAgo.getFullYear();
			const month = needDaysAgo.getMonth() + 1; // 月份是从0开始的，所以加1
			const date = needDaysAgo.getDate();
			return `${year}-${month}-${date}`;
		},
		getUserPreference(){
			getUserPreference().then((data) => {
				this.volumeSettings = JSON.parse(data.data[0].eatenVolume)
			})
		},
		getEatenVolumeType(index){
			switch(index % 4){
				case 0:
					return 'primary'
				case 1:
					return 'info'
				case 2:
					return 'warning'
				case 3:
					return 'danger'
			}
		}
	},
	mounted() {
		this.getUserPreference();
		this.getList();
		this.getGoldPrice();
		if (this.intervalId) {
			clearInterval(this.intervalId)
		}
		this.intervalId = setInterval(() => {
			this.getList()
		}, 20000);
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	/* Q版：柔和底色 + 贴纸卡片 */
	--q-bg0: #fff7fb;
	--q-bg1: #f2fbff;
	--q-card: rgba(255, 255, 255, 0.92);
	--q-line: rgba(15, 23, 42, 0.08);
	--q-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);
	--q-shadow-sm: 0 6px 14px rgba(17, 24, 39, 0.08);
	--q-radius: 18px;
	--q-primary: #34c3ff;
	--q-primary-2: #6ee7ff;
	--q-danger: #ff5f7a;

	padding: 14px 14px 18px;
	display: flex;
	flex-direction: column;
	height: 100%;
	box-sizing: border-box;
	position: relative;
	font-family: "Comic Sans MS", "Microsoft YaHei UI", "PingFang SC", "Hiragino Sans GB", system-ui, -apple-system,
		BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
	background: radial-gradient(120% 90% at 20% 0%, var(--q-bg0) 0%, transparent 60%),
		radial-gradient(120% 90% at 90% 30%, var(--q-bg1) 0%, transparent 55%),
		#ffffff;
}

.content::before,
.content::after {
	content: "";
	position: fixed;
	z-index: -1;
	pointer-events: none;
	opacity: 0.9;
}
.content::before {
	width: 240px;
	height: 240px;
	left: -90px;
	top: 120px;
	background: radial-gradient(circle at 30% 30%, rgba(255, 184, 220, 0.55), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(110, 231, 255, 0.45), transparent 62%);
	border-radius: 999px;
}
.content::after {
	width: 280px;
	height: 280px;
	right: -140px;
	bottom: 80px;
	background: radial-gradient(circle at 40% 30%, rgba(196, 255, 214, 0.5), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(255, 224, 170, 0.45), transparent 62%);
	border-radius: 999px;
}
/* 不要对 `.content > *` 统一加 position/z-index，会破坏 Vant Dialog/Popup 的 fixed 布局 */

.content /deep/ .van-button {
	border-radius: 999px;
	transition: transform 120ms ease, filter 120ms ease;
}
.content /deep/ .van-button:active {
	transform: translateY(1px) scale(0.985);
	filter: saturate(1.05);
}
.content /deep/ .van-button--primary {
	border: none;
	background: linear-gradient(180deg, var(--q-primary) 0%, var(--q-primary-2) 100%);
	box-shadow: 0 8px 18px rgba(52, 195, 255, 0.22);
}
.content /deep/ .van-button--danger {
	border: none;
	background: linear-gradient(180deg, #ff6b84 0%, var(--q-danger) 100%);
	box-shadow: 0 8px 18px rgba(255, 95, 122, 0.22);
}
.content /deep/ .van-button--plain.van-button--primary {
	border: 1px solid rgba(52, 195, 255, 0.55);
	background: rgba(255, 255, 255, 0.86);
	color: #0ea5e9;
	box-shadow: 0 6px 14px rgba(52, 195, 255, 0.12);
}

.time_select {
	display: flex;
	justify-content: space-around;
	padding: 8px;
	gap: 6px;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
}

.time_select /deep/ .van-button {
	flex: 1 !important;
	padding: 0 6px;
	height: 30px;
	line-height: 30px;
	font-size: 12px;
}

.time_selected /deep/ .van-button {
	opacity: 0.2;
}

.time_selected /deep/ .selected_button {
	opacity: 1;
}

.today-num {
	display: flex;
	justify-content: space-between;
}

.gold_price{
	font-size: 12px;
}

.vertical-data{
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

.current_time {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding: 8px 10px;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);
}

.custom_time {
	display: flex;
	align-items: center;
	font-size: 13px;
}

.final_data {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 6px;
	padding: 10px 10px;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: var(--q-card);
	box-shadow: var(--q-shadow-sm);

	>div {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
}

.final_data>div {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.custom_time /deep/ .van-field {
	width: 150px;
	padding: 0;
	margin: 4px 6px;
}

.custom_time /deep/ .van-field__control {
	font-size: 13px;
	height: 28px;
	line-height: 28px;
}

.final_data /deep/ .van-button {
	height: 32px;
	line-height: 32px;
	font-size: 12px;
	padding: 0 10px;
}

.data-list-header {
	margin-bottom: 12px;
}

.data-list {
	flex: 1;
	display: flex;
	flex-direction: column;
	overflow: auto;
	margin-top: 12px;
	margin-bottom: 6px;
	border: 1px solid var(--q-line);
	border-radius: var(--q-radius);
	background: rgba(255, 255, 255, 0.86);
	box-shadow: var(--q-shadow-sm);
	padding: 10px 10px 6px;
	box-sizing: border-box;
}

.data-list-item {
	display: flex;
	align-items: center;
	margin-bottom: 8px;
}

.data-list_time {
	flex: 1;
}

.data-list_operate {
	width: 50px;
}

.data-list_num {
	width: 72px;
}

.data-list_interval {
	width: 72px;
}

.data-list-content {
	height: 360px;
	overflow-y: auto;
	flex: 1;
	font-size: 14px;
}

.last-eat {
	display: flex;
	flex-direction: column;
	gap: 1px;
	border: 2px solid transparent;
	border-radius: 20px;
	padding: 10px 10px 8px;
	background: linear-gradient(var(--q-card), var(--q-card)) padding-box,
		linear-gradient(135deg, rgba(52, 195, 255, 0.45), rgba(255, 107, 132, 0.35), rgba(45, 212, 191, 0.35)) border-box;
	box-shadow: var(--q-shadow);
	position: relative;
	font-size: 12px;
	line-height: 1.3;
}

.last-eat::after {
	content: "🍼";
	position: absolute;
	right: 12px;
	top: 10px;
	font-size: 18px;
	opacity: 0.85;
	transform: rotate(10deg);
	pointer-events: none;
}

.bule-font {
	color: #0ea5e9;
	font-weight: 700;
}

.red-font {
	color: #ee0a24;
}

.bold-font {
	font-weight: bold;
}

.red-font {
	color: #ee0a24;
}
</style>
